import { CommonModule as NgCommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatBadgeModule } from "@angular/material/badge";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatToolbarModule } from "@angular/material/toolbar";
import { EffectsModule } from "@ngrx/effects";
import { TranslateModule } from "@ngx-translate/core";
import { LazyLoaderModule } from "@obg/common.lazy-loader";
import { MatCommonLoginModule } from "@obg/common.login";
import { CustomerSupportLinkDirective } from "@obg/core.customer-support";
import { RegulatoryBarModule } from "@obg/core.regulatory-bar";
import { MatCommonModule } from "@obg/mat.ui.common";
import { MatCoreModule } from "@obg/mat.ui.core";
import { MatGlobalModule } from "@obg/mat.ui.global";
import { CoreModule } from "@obg/ngx.core";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";
import { BetaBadgeModule, CoreUiModule, RegulatoryItemsModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { LanguageSelectorModule } from "../language-selector/language-selector.module";

import { AccountControlContainer } from "./account-control/account-control.container";
import { HeaderContainer } from "./header.container";
import { HeaderEffect } from "./header.effect";
import { OmsSummaryListLocalizeTimePipe } from "./oms/oms-summary-list/oms-summary-list-localize-time.pipe";
import { OmsSummaryListComponent } from "./oms/oms-summary-list/oms-summary-list.component";
import { OmsSummaryContainer } from "./oms/oms-summary.container";

@NgModule({
	imports: [
		NgCommonModule,
		CoreModule,
		CoreUiModule,
		GlobalModule,
		MatCoreModule,
		MatGlobalModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatToolbarModule,
		MatBadgeModule,
		BetaBadgeModule,
		RegulatoryBarModule,
		RegulatoryItemsModule,
		TranslateModule,
		GlobalUiModule,
		RouterModule,
		MatCommonModule,
		LanguageSelectorModule,
		MatCommonLoginModule,
		LazyLoaderModule,
		CustomerSupportLinkDirective,
		EffectsModule.forFeature([HeaderEffect]),
	],
	exports: [HeaderContainer, AccountControlContainer],
	declarations: [
		AccountControlContainer,
		HeaderContainer,
		OmsSummaryContainer,
		OmsSummaryListComponent,
		OmsSummaryListLocalizeTimePipe,
	],
})
export class HeaderModule {}
